import {DetailsPageContent, DetailsPageWrapper} from '@/components/ui/details-atoms/DetailsAtoms'
import {TreatmentRequestDetailsSections} from '@/features/treatment-requests/components/treatment-request-details-sections/TreatmentRequestDetailsSections'
import {TreatmentRequestActivityLogs} from '@/features/entity-activity-logs/components/project-activity-logs/TreatmentRequestActivityLogs'
import {TreatmentRequestHeroSection} from '@/features/treatment-requests/components/treatment-request-hero-section/TreatmentRequestHeroSection'

export const TreatmentRequestDetails = () => {
    return (
        <DetailsPageWrapper isSuccess>
            <TreatmentRequestHeroSection />
            <DetailsPageContent>
                <TreatmentRequestDetailsSections />
                <TreatmentRequestActivityLogs />
            </DetailsPageContent>
        </DetailsPageWrapper>
    )
}
